$(document).ready(function() {
  $('.quick-add .quick-add__submit').on('click', function() {
    var checkInterval = setInterval(function() {
      var $productFormButtons = $('.product-form__buttons');
      var $addToCartButton = $productFormButtons.find("button[name='add']");
      var $gokwikBuyNowButton = $productFormButtons.find("button#gokwik-buy-now");

      if ($addToCartButton.length && $gokwikBuyNowButton.length) {
        if (!$addToCartButton.prop('disabled')) {
          $gokwikBuyNowButton.prop('disabled', false);
          $gokwikBuyNowButton.removeClass('disabled');
          clearInterval(checkInterval); 
        } else {
          $gokwikBuyNowButton.prop('disabled', true);
          $gokwikBuyNowButton.addClass('disabled');
        }
      }
    }, 500);
  });
});
  $(document).ready(function() {
    $('#customer_login').submit(function(event) {
      let isValid = true;
      
      const email = $('#CustomerEmail').val();
      const password = $('#CustomerPassword').val();

      // Reset previous error messages
      $('.contact__field-error').remove();

      if (email.trim() === '') {
        $('#CustomerEmail').after('<small class="contact__field-error"><span class="form__message">Email is required.</span></small>');
        isValid = false;
      } else {
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        if (!emailRegex.test(email)) {
          $('#CustomerEmail').after('<small class="contact__field-error"><span class="form__message">Please enter a valid email address.</span></small>');
          isValid = false;
        }
      }

      if (password.trim() === '') {
        $('#CustomerPassword').after('<small class="contact__field-error"><span class="form__message">Password is required.</span></small>');
        isValid = false;
      } else if (password.length < 6) {
        $('#CustomerPassword').after('<small class="contact__field-error"><span class="form__message">Password must be at least 6 characters long.</span></small>');
        isValid = false;
      }

      if (!isValid) {
        event.preventDefault();
      }
    });

    // Remove error message on input change
    $('#CustomerEmail, #CustomerPassword').on('input', function() {
      $(this).next('.contact__field-error').remove();
    });
  });
$(document).ready(function() {
  $('#create_customer').submit(function(event) {
    let isValid = true;
    const email = $('#RegisterForm-email').val();
    const password = $('#RegisterForm-password').val();
    $('.form__message').remove();
    if (email.trim() === '') {
      $('#RegisterForm-email').after('<span class="form__message"><svg aria-hidden="true" focusable="false"><use href="#icon-error"></use></svg> Email can\'t be blank.</span>');
      isValid = false;
    } else {
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA0-9]{2,6}$/;
      if (!emailRegex.test(email)) {
        $('#RegisterForm-email').after('<span class="form__message"><svg aria-hidden="true" focusable="false"><use href="#icon-error"></use></svg> Please enter a valid email address.</span>');
        isValid = false;
      }
    }
    if (password.trim() === '') {
        $('#RegisterForm-password').after('<span class="form__message"><svg aria-hidden="true" focusable="false"><use href="#icon-error"></use></svg> Password can\'t be blank.</span>');
        isValid = false;
      } else if (password.length < 6) {
        $('#RegisterForm-password').after('<span class="form__message"><svg aria-hidden="true" focusable="false"><use href="#icon-error"></use></svg> Password must be at least 6 characters long.</span>');
        isValid = false;
      }
    if (!isValid) {
      event.preventDefault(); 
    }
  });

  $('#RegisterForm-email, #RegisterForm-password').on('input', function() {
    $(this).next('.form__message').remove();
  });
});